

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface GenericParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
  
}

export interface Generic {
    id?: number;
    
    name:string;
    
  parameters?: GenericParameter[];
  links?: any;
}

export abstract class GenericData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(): Observable<Generic[]>;
  abstract genericListSearch(searchWord:string): Observable<Generic[]>;

  
  abstract create(url: string,data: Generic): Observable<any>;
  abstract update(url: string,data: Generic): Observable<any>;
  abstract delete(url: string): Observable<any>;
  abstract searchList(url:string,data:any): Observable<any>;

  //uploadData
  abstract postData(url: string,data: any[]): Observable<any>;

}